import { render, staticRenderFns } from "./OptometristOrder.vue?vue&type=template&id=79bfd70b&scoped=true&"
import script from "./OptometristOrder.vue?vue&type=script&lang=js&"
export * from "./OptometristOrder.vue?vue&type=script&lang=js&"
import style0 from "./OptometristOrder.vue?vue&type=style&index=0&id=79bfd70b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bfd70b",
  null
  
)

export default component.exports